import { GetterTree } from 'vuex';
import { CartState } from './types';
import { RootState } from '../types';
import { IProductProperty } from '@resclick/data-access';

export const getters: GetterTree<CartState, RootState> = {
  products: (state) => state.products,
  total: (state) => {
    const total = state?.total || { value: 0, currency: 'EUR' };

    return {
      value: total.value,
      currency: total.currency,
    };
  },
  isLoading: (state) => {
    return state.isLoading;
  },
};
